import RequestAbstract from "./RequestAbstract";

export default class Report extends RequestAbstract {
    get link() {
        return this.links.report;
    }

    async getOneRow(url, info) {
        return this.post(this.links.report + `/${url}/SINGLE_ROW`, info);
    }

    async getMultiRow(url, info) {
        return this.post(this.links.report + `/${url}/MULTI_ROW`, info);
    }
}
